<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="false"
      :hideEdit="true"
      :viewTo="viewTo"
      @onDeleteClicked="onDeleteClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '../../directives/button-options';

export default {
  name: 'UserEdit',
  components: { ButtonOptions },
  props: ['access', 'user', 'viewTo'],
  computed: {
    data() {
      return { ...this.user };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
